import React from 'react';
import styled from 'styled-components';

const Guide = styled.section`
    margin:0 24px 24px; padding:18px; border:1px solid #f1c3c6;
    border-radius:8px; background:#fffafb;
    h3 {margin:0 0 10px; color:#d5222b; font-size:15px;}
    p, ol {font-size:13px; color:#555; line-height:1.7;}
    .affected {margin:14px 0 18px; padding:14px 16px; border:1px solid #efb3b7;
        border-left:4px solid #d5222b; border-radius:6px; background:#fff;}
    .affected-label {display:block; margin-bottom:8px; color:#a01920; font-size:13px; font-weight:700;}
    .affected-devices {display:flex; flex-wrap:wrap; gap:8px;}
    .affected-device {display:inline-block; padding:6px 12px; border-radius:5px;
        background:#fce9eb; color:#a01920; font-size:17px; font-weight:700; line-height:1.5;}
    ol {padding-left:22px; margin-bottom:0;}
    li + li {margin-top:8px;}
`;

export default function AppIssueGuide({type, devices}) {
    const abnormal = devices.filter(device => device.appStatus
        ? device.appStatus === 'abnormal'
        : !(device.active === device.devicetype || (type === 'running' && device.active === 'kiosk')));
    if (!abnormal.length) return null;
    const label = type === 'tv' ? 'TV' : type === 'weight' ? '웨이트' : '러닝';
    const equipment = type === 'tv' ? 'TV와 연결된 앱 실행 기기' : '태블릿';
    return <Guide aria-label={`${label} 앱 이상 안내`}>
        <h3>앱 연결이 확인되지 않습니다. {equipment} 상태를 확인해 주세요.</h3>
        <div className="affected" role="group" aria-label="확인할 기기">
            <span className="affected-label">확인할 기기</span>
            <div className="affected-devices">
                {abnormal.map(device => <strong className="affected-device" key={device.devicetype + ':' + device.number}>
                    {label} {device.number}번
                </strong>)}
            </div>
        </div>
        <ol>
            <li><strong>전원 확인</strong> — {equipment}의 전원이 켜져 있는지, 전원 케이블이 연결되어 있는지 확인해 주세요.</li>
            <li><strong>인터넷 연결 확인</strong> — Wi-Fi 또는 유선 인터넷이 정상적으로 연결되어 있는지 확인해 주세요.</li>
            <li><strong>제타트랙 앱 확인</strong> — 앱이 실행되어 있는지 확인하고, 종료되어 있으면 다시 실행해 주세요. 화면이 멈춰 있으면 앱을 종료한 뒤 다시 실행해 주세요.</li>
            <li><strong>상태 다시 확인</strong> — 잠시 후 ‘앱 정상’으로 바뀌는지 확인해 주세요. 계속 비정상이면 기기를 재시작하고, 해결되지 않으면 고객지원에 문의해 주세요.</li>
        </ol>
    </Guide>;
}
